// @flow

import buildOptionsKey from 'app/common/redux/reducers/resources/buildOptionsKey';
import type { Action } from 'app/common/redux/types';
import typeof { resources } from 'node/resources/routes';

type ResourceName = $Keys<resources>;

export type State = {
  [resourceName: ResourceName]: {
    [resourceOptions: string]: true,
  },
};

const fetching = (state: State = {}, action: Action): State => {
  if (action.type === 'RESOURCE_FETCH_CREATE') {
    const { name, options } = action.payload;
    return {
      ...state,
      [name]: {
        ...(state[name] || {}),
        [buildOptionsKey(options)]: true,
      },
    };
  } else if (
    action.type === 'RESOURCE_FETCH_COMPLETE' ||
    action.type === 'RESOURCE_FETCH_MORE_COMPLETE'
  ) {
    const { name, options } = action.payload;
    const nextState = {
      ...state,
      [name]: { ...(state[name] || {}) },
    };
    const optionsKey = buildOptionsKey(options);
    delete nextState[name][optionsKey];
    if (Object.keys(nextState[name]).length === 0) {
      delete nextState[name];
    }
    return nextState;
  }
  return state;
};

export default fetching;
